import getEnv, { PROD } from './getEnv';

/**
 * On nonprod always returns true and if on live returns true a specified percentage of the time.
 *
 * @param {number} [percentage=10] - The percentage of time to return true on prod (0-100)
 * @returns {boolean} true specified percentage of the time on prod and 100% of the time on NP
 * @example
 */
const eventShouldBeTracked = (percentage = 10) =>
	getEnv() !== PROD ||
	Math.floor(Math.random() * (100 - 0) + 1) <= percentage;

export default eventShouldBeTracked;
